module.exports = __webpack_public_path__ + "img/de.164eda5c.svg";